import {
  AttributeTypeId,
  CustomAttributeFilterEntry,
} from "@knowfully/ui.common";
import SpotlightsFilter from "./SpotlightsFilter";

export const customAttributeFilterComponents: CustomAttributeFilterEntry[] = [
  {
    attributeTypeId: AttributeTypeId.Spotlight,
    FilterComponent: SpotlightsFilter,
  },
];
